<style lang="scss">
    .main-box{
        background: #ffffff;
        min-height:600px;
    }
    .page-title {
        padding: 20px 40px 5px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;
            float:left;
            line-height:55px;

        }
        .guangfa{
            width:220px;
            float:right;
            text-align:center;
            img{width:166px;height:40px;}
            span{
                font-size:12px;
                color:#c2c4ca;
                display: block;
            }
        }
    }
    .guide-box{

        .pic-guide{
            div{
                float:left
            }
            text-align: center;
            margin:80px 180px;
            .left{
                padding-top:20px;
                img{
                    width:200px;
                    height:43px;
                }
            }
            .center{
                width:162px;
                img{
                    width:162px;
                    height:35px;

                }
            }
            .right{
                padding-top:20px;
                img{
                    width:249px;
                    height:60px;
                }
            }
        }
        .desc{
            margin:0 180px;
            h3{
                font-size:18px;
                font-weight:normal;
                color:#333333;
            }
            p{
                margin:20px 0;
                font-size:14px;
                color:#f68321;
                line-height:24px;
            }
        }
    }
</style>


<template>
  <Layout>
    <!--<h1>我的账户</h1>-->
   <div class="main-box">
       <div class="page-title clearfix">
           <h2 v-if="$route.query.toCreate">广发开户</h2>
           <div class="guangfa"><img src="../assets/images/guangfa.png" alt=""> <span>宜人贷与广发银行合作网贷资金存管业务</span></div>
       </div>
       <div class="guide-box">
           <div class="pic-guide clearfix">
               <div class="left">
                   <img src="../assets/images/logo2.png" alt="">
               </div>
               <div class="center">
                   <span>您将跳转至广发银行 <br>完成后续操作</span>
                   <img src="../assets/images/youjiantou.jpg" alt="">
               </div>
               <div class="right">
                   <img src="../assets/images/guangfa.png" alt="">

               </div>

           </div>
           <div v-if="showBox" class="desc">
               <h3>为了您的后续操作，需要您开通资金存管账户。</h3>
                <p>
                    开通提示：<br>
                    1. 提供一张您本人的借记卡(已支持 15 家银行)<br>
                    2. 提供借记卡的预留手机号<br>
                    3. 设置交易密码，请您牢记。<br>
                    注：请使用IE浏览器打开<br>
                </p>
               <el-button size="medium" type="primary" @click="goGuangfa">去开户</el-button>

           </div>
       </div>
   </div>

  </Layout>
</template>
<script>
	import Layout from './layouts/main'


	export default {
		data(){
			return {lastRouterName:''}
        },

		components: { Layout  },
		computed: {
			showBox () {
				// 我们很快就会看到 `params` 是什么
				return this.$route.query.toCreate === '1'
			}
		},

        methods:{
			goGuangfa(){
				_hmt.push(['_trackEvent', '点击事件', '广发开户-去开户']);
				// return console.log(decodeURIComponent(this.$route.query.redirect))
				window.location.href=decodeURIComponent(this.$route.query.redirect)
            }
        },
        mounted(){
			let timer = null
			window.addEventListener('popstate',()=>{
				clearTimeout(timer)

			},false)

			if(!this.$route.query.toCreate){
				timer=setTimeout(()=>{

					if(this.$route.name == 'guangfaRedirect'){
						this.goGuangfa()
					}
				},3000)
            }
        }
	}
</script>
